import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export const useUser = computed(() => usePage().props.value.authUser)
